import React from 'react';
import plusIcon from "../assets/images/img_plus.png";
import purpleRectangle from "../assets/images/usernameBorder.png";
import coinBackground from "../assets/images/header_item_back.png";
import goldCoin from "../assets/images/ic_coin.png";
import silverCoin from "../assets/images/ic_silver_coin.png";
import stateStar from "../assets/images/state_star.png";
import Grid from '@material-ui/core/Grid';
import {data} from "../Store/Actions/DataAction";
import {connect} from "react-redux";
import {stars} from "../Store/Actions/StarsAction";
import {questionNumber} from "../Store/Actions/QuestionNumberAction";
import {giftHallDialog} from "../Store/Actions/GiftHallDialogAction";
import {coinType} from "../Store/Actions/CoinTypeVisibleAction";
import Button from "./pageComponents/Settings/Free/Button";
import PicoLoader from "./pageComponents/Common/PicoLoader";
import DialogContent from "@material-ui/core/DialogContent";
import HelpDialog from "./pageComponents/Home/GiftHall/HelpDialog";
import Dialog from "@material-ui/core/Dialog";
import axios from "axios";
import { giftHallHelp} from "../Utility/Url";
import SingleAvatar from "./pageComponents/Settings/SingleAvatar";
import GoldBanner from "../assets/images/gold_banner.png";
import {numberSplitor, textAbbreviation} from "../Utility/Func";
import LoginButton from "./pageComponents/Home/LoginButton";
import star from "../assets/images/img_star.png";
import invisibleStar from "../assets/images/invisibleStar.png";
import {withRouter} from "react-router-dom";
import {BOTHCOINVISIBLE, GOLDENCOINVISIBLE, SILVERCOINVISIBLE} from "../Store/Actions/Types";


class ButtonAppBar extends React.Component {
    constructor() {
        super()
        this.state={
            showDialog:false,
            interval:null,
            toolbarType:null,
            rxDataLoaded:false,
            picoSmallLoader:false,
            giftHallHelpDialog:null,
            increment:true,
            style: {
                root: {
                    overflow:'hidden',
                    width:'100%',
                    // marginBottom:'20px'
                },
                usernameSection:{
                    position:'relative',
                    textAlign:'center',
                    display:'flex',
                    alignItems:'center',
                    alignContent:"center",
                    justifyContent:'center',
                    padding:'10px',
                },
                rectangle:{
                    position:'absolute',
                    width:'90%',
                },
                circle:{
                    right :'2%',
                    width:'25%',
                    borderRadius:'50%',
                    position: 'absolute',
                    overflow: 'hidden',
                    backgroundColor: 'red'
                },
                paragraph:{
                    position:'absolute',
                    color: 'white',
                    textAlign:'center',
                },
                balanceSection:{
                    // marginTop:'10px'
                },
                coinSection:{
                    position:'relative',
                    backgroundImage:`url(${coinBackground})`,
                    backgroundRepeat:'no-repeat',
                    backgroundSize:'contain',
                    backgroundPosition:'center'
                },
                coin:{
                    width:'100%',
                    transform:'translateX(-10%) scale(1.1)'
                },
                plusIcon:{
                    width:'100%',
                    transform:'translateX(10%)  scale(1.1)'
                },
                coinText:{
                    color:'white',
                    zIndex:2,
                    fontSize:'20px'
                }
            }
        }
    }
    checkLoading=()=>{
        if (this.props.UserData.userData!=null)
            if (!this.state.rxDataLoaded){
                this.setState({
                    rxDataLoaded:true
                })
                clearInterval(this.state.interval)
            }
    }
    dataInterval=() =>{
         const interval =  setInterval(this.checkLoading, 100);
         this.setState({
             interval:interval
         });
     }
    handleClick=async()=>{
        this.setState({
            picoSmallLoader:true,
        })
        await axios.get(giftHallHelp)
            .then(res => {
                const {data}=res
                // this.props.callBack(data)
                this.setState({
                    giftHallHelpDialog:data,
                    picoSmallLoader:false,
                    showDialog:true

                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    componentDidMount()
    {
        this.dataInterval()
        if (this.props.increment!==undefined){
            this.setState({
                increment:this.props.increment
            })
        }

     }
     componentDidUpdate() {
         if (this.props.UserData.userData!=null)
             if (!this.state.rxDataLoaded){
                 this.setState({
                     rxDataLoaded:true
                 })
                 if (this.state.interval)
                 clearInterval(this.state.interval)
             }
     }
     render(){
         const {style,rxDataLoaded,picoSmallLoader,showDialog,giftHallHelpDialog,increment}
         = this.state;
         const data=this.props.UserData.userData
         const starVisible=this.props.Stars.visible
         const giftHallDialog=this.props.GiftHallDialog.visible
         const coinType=this.props.CoinType.coinType
         let guest =false
         if (data)
             guest=data.userInfo.mobile===''
         let questionNumberData=null
         if (this.props.QuestionNumber)
             questionNumberData=this.props.QuestionNumber.data
         const button={
             text:'راهنما ؟',
             backgroundColor:'blue',
             bottomFontSize:'15px',
             buttonTextColor:'#ffffff'
         }
         const loginButton={
             text:'ورود'
         }
         const handleClose=(()=>{
             this.setState({
                 showDialog:false
             })
         })
         let avatarData= {
             icon:''
         }
         if (data){
             const {userInfo:{name,avatar}}=data
             avatarData= {
                 icon:avatar
             }
         }
         return (
             <Grid style={style.root} alignItems={"center"} container justify={"center"}>
                 <Dialog
                     // disableBackdropClick
                     open={this.state.showDialog}
                     onClose={handleClose}
                     aria-labelledby="alert-dialog-title"
                     aria-describedby="alert-dialog-description"
                     style={{background:'transparent !important'}}
                     PaperProps={{
                         style: {
                             backgroundColor: 'transparent',
                             boxShadow: 'none',
                         },
                     }}
                 >
                     <DialogContent>
                         <HelpDialog data={giftHallHelpDialog}/>
                     </DialogContent>
                 </Dialog>
                 {this.props.type==='sideToolbar' &&
                 <Grid item container alignItems={"center"} sm={12} xs={12} style={{padding:'0px 10px'}}>
                     <Grid direction='row-reverse' alignItems={'center'} alignContent="center" container item
                           xs={12} sm={12} style={style.balanceSection}
                           justify={coinType===BOTHCOINVISIBLE?'flex-start':'space-between'}
                     >
                         {
                             (coinType === BOTHCOINVISIBLE || coinType === SILVERCOINVISIBLE) &&
                             <Grid container alignItems={"center"} justify={"center"} xs={4} sm={4}
                                   style={{padding:'8px'}}
                                   className='clickable' onClick={()=>{
                                 this.props.history.push('/shop')
                             }}>
                                 <Grid container alignItems='center' justify={"space-between"} style={style.coinSection}>
                                     <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                         <img src={silverCoin} style={style.coin} alt=""/>
                                     </Grid>
                                     <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                         {
                                             rxDataLoaded &&
                                             <h2 style={style.coinText}>
                                                 {data.properties.silver}
                                             </h2>
                                         }
                                         {
                                             !rxDataLoaded &&
                                             <Grid item className='loader'/>
                                         }
                                     </Grid>

                                     <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                         {increment &&
                                         <img src={plusIcon} style={style.plusIcon} alt=""/>
                                         }
                                     </Grid>
                                 </Grid>
                             </Grid>
                         }
                         {
                             (coinType === BOTHCOINVISIBLE || coinType === GOLDENCOINVISIBLE) &&
                             <Grid container alignItems={"center"} justify={"center"} xs={4} sm={4}
                                   style={{padding: '8px'}}
                                   className='clickable' onClick={() => {
                                 this.props.history.push('/shop')
                             }}
                             >
                                 <Grid container alignItems='center' justify={"space-between"}
                                       style={style.coinSection}>
                                     <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                         <img src={goldCoin} style={style.coin} alt=""/>
                                     </Grid>
                                     <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                         {
                                             rxDataLoaded &&
                                             <h2 style={style.coinText}>
                                                 {data.properties.golden}
                                             </h2>
                                         }
                                         {
                                             !rxDataLoaded &&
                                             <Grid item className='loader'>
                                             </Grid>
                                         }
                                     </Grid>
                                     <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                         {increment &&
                                         <img src={plusIcon} style={style.plusIcon} alt=""/>
                                         }
                                     </Grid>
                                 </Grid>
                             </Grid>
                         }
                         { starVisible &&
                             <Grid container xs={4} sm={4} alignItems='center' justify={"space-between"}  style={style.coinSection}>
                                 <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                     <img src={stateStar} style={style.coin} alt=""/>
                                 </Grid>
                                 <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                     {
                                         rxDataLoaded &&
                                         <h2 style={style.coinText}>
                                             {data.stats.stars}
                                         </h2>
                                     }
                                     {
                                         !rxDataLoaded &&
                                         <Grid item className='loader'>
                                         </Grid>
                                     }
                                 </Grid>
                                 <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                     {/*<img src={plusIcon} style={style.plusIcon} alt=""/>*/}
                                 </Grid>
                             </Grid>
                         }
                         { (questionNumberData) &&
                             <Grid container xs={4} sm={4} alignItems='center' justify={"center"}>
                                     {
                                         (rxDataLoaded && (questionNumberData.visible && questionNumberData.type !=='normal'))  &&
                                         <Grid container alignItems='center' justify={"center"} style={style.coinSection}>
                                             <h2 style={{...style.coinText}}>
                                                  تصویر شماره {questionNumberData.count}
                                             </h2>
                                         </Grid>
                                     }
                                     {
                                         (rxDataLoaded && (questionNumberData.visible && questionNumberData.type ==='normal'))  &&
                                         <Grid container alignItems={"center"} justify={"space-around"} xs={12} sm={12}
                                               className='prize-frame-star-holder'
                                               direction={"row"}
                                               style={{
                                                   ...style.coinSection,
                                                   height:'auto',
                                                   top:'auto',
                                                   padding:'3px'

                                               }}
                                         >
                                             <Grid sm={3} container xs={3} alignItems={"center"} justify={"center"}
                                                   style={{alignSelf:'center'}}
                                             >
                                                 <img src={questionNumberData.count>0?star:invisibleStar} alt=""/>
                                             </Grid>
                                             <Grid sm={3} container xs={3} alignItems={"center"} justify={"center"}
                                                   style={{alignSelf:'self-start'}}
                                             >
                                                 <img src={questionNumberData.count>1?star:invisibleStar}/>
                                             </Grid>
                                             <Grid sm={3} container xs={3} alignItems={"center"} justify={"center"}
                                                   style={{alignSelf:'center'}}
                                             >
                                                 <img src={questionNumberData.count>2?star:invisibleStar}/>
                                             </Grid>
                                         </Grid>
                                     }
                             </Grid>
                         }
                         {
                           giftHallDialog &&
                           <Grid container xs={4} sm={4} alignItems='center' justify={picoSmallLoader?'center':"space-between"}>
                                 {
                                     !picoSmallLoader&&
                                     <Grid sm={12} style={{position:'relative',height:'60px'}} xs={12} alignItems={"center"} onClick={() => { this.handleClick() }} className='clickable' justify={"center"} container>
                                         <Button data={button}/>
                                     </Grid>
                                 }
                                 {
                                     picoSmallLoader &&
                                     <Grid sm={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                           style={{position:'relative',height:'100%'}}
                                     >
                                         <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                             <PicoLoader/>
                                         </Grid>
                                     </Grid>
                                 }
                             </Grid>
                         }
                     </Grid>
                 </Grid>
                 }
                 {this.props.type==='mainToolbar' &&
                 <Grid item container justify={"space-between"} alignItems={"center"} xs={11} sm={11}>
                     <Grid direction='column' alignItems='center' alignContent="center" container item xs={4} sm={4} style={
                         style.balanceSection}
                     >
                         <Grid container alignContent={"center"} alignItems='center' justify={"space-between"}
                               style={{...style.coinSection,height:'40px'}}
                               className='clickable'
                               onClick={()=>{
                                     this.props.history.push('/shop')
                                 }}>
                             <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                 <img src={goldCoin} style={style.coin} alt=""/>
                             </Grid>
                             <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                 {
                                     rxDataLoaded &&
                                     <h2 style={style.coinText}>
                                         {numberSplitor(data.properties.golden)}
                                     </h2>
                                 }
                                 {
                                     !rxDataLoaded &&
                                     <Grid item className='loader'>
                                     </Grid>
                                 }
                             </Grid>
                             <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                 <img src={plusIcon} style={style.plusIcon} alt=""/>
                             </Grid>
                         </Grid>
                         <Grid container alignContent={"center"} alignItems='center'  justify={"space-between"}
                               style={{...style.coinSection,height:'40px'}}
                               className='clickable'
                               onClick={()=>{
                                     this.props.history.push('/shop')
                                 }}>
                             <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                 <img src={silverCoin} style={style.coin} alt=""/>
                             </Grid>
                             <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                 {
                                     rxDataLoaded &&
                                     <h2 style={style.coinText}>
                                         {
                                             numberSplitor(data.properties.silver)
                                         }
                                     </h2>
                                 }
                                 {
                                     !rxDataLoaded &&
                                     <Grid item className='loader'>
                                     </Grid>
                                 }
                             </Grid>
                             <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                 <img src={plusIcon} style={style.plusIcon} alt=""/>
                             </Grid>
                         </Grid>
                     </Grid>
                     <Grid container item xs={7} sm={7} direction={"row-reverse"}
                           alignContent={"center"}
                           justify={"flex-start"}
                         style={{
                             // backgroundImage: "url(" + purpleRectangle + ")",
                             // backgroundSize:'contain',
                             // backgroundRepeat: 'no-repeat',
                             // backgroundPosition:'50%',
                             position:'relative'
                         }
                         }
                     >
                         {/*<img src={purpleRectangle} style={style.rectangle} alt=""/>*/}
                         {/*<img src={circleWood} style={style.circle} alt=""/>*/}

                         <Grid container alignItems={"center"} alignContent={"center"} xs={3} sm={3}
                            style={{
                            position:'absolute',
                            width:'100%',
                            height:'100%',
                                zIndex:'5'
                            }}
                         >
                             <SingleAvatar data={avatarData} style={style.circle}/>
                         </Grid>
                         <Grid container justify={"flex-start"} alignItems={"center"} alignContent={"center"}
                               style={{
                                   // backgroundColor:'rgba(255,255,255,0.4)',
                                   backgroundImage: "url(" + purpleRectangle + ")",
                                   backgroundSize:'100% 100%',
                                   backgroundRepeat: 'no-repeat',
                                   backgroundPosition:'50%',
                                   position:'relative',
                                   // backgroundColor:'red'
                               }}
                               xs={9}
                               sm={9}
                         >
                             <Grid container justify={"flex-start"} alignItems={"center"}
                                   sm={1} xs={1} >

                             </Grid>
                             { guest &&
                                 <>
                                     <Grid container justify={"flex-start"} alignItems={"center"}
                                           sm={3} xs={3}
                                           onClick={()=>{
                                               this.props.history.push('/login')}
                                           }
                                     >

                                         <LoginButton data={loginButton}/>
                                     </Grid>
                                     <Grid container justify={"center"} alignItems={"center"}
                                           sm={4} xs={4} style={{
                                         // backgroundColor:'rgba(255,255,251,0.4)'
                                     }}
                                     >
                                         {
                                             rxDataLoaded &&
                                             <p className='home-toolbar-username'>
                                                 {
                                                     guest &&
                                                     textAbbreviation(data.userInfo.name,7)
                                                 }
                                                 {/*ایمان حاحی مصطفی زاده*/}
                                                 {/*بیشتر از چند حرف که زد بیرون 3 نقطع شود */}
                                             </p>
                                         }
                                         {
                                             !rxDataLoaded &&
                                             <Grid item className='loader'/>
                                         }
                                     </Grid>
                                 </>
                             }
                             { !guest &&
                             <>
                                 {/*<Grid container justify={"flex-start"} alignItems={"center"}*/}
                                 {/*      sm={3} xs={3}*/}
                                 {/*      onClick={()=>{*/}
                                 {/*          this.props.history.push('/login')}*/}
                                 {/*      }*/}
                                 {/*>*/}

                                 {/*    <LoginButton data={loginButton}/>*/}
                                 {/*</Grid>*/}
                                 <Grid container justify={"center"} alignItems={"center"}
                                       sm={7} xs={7} style={{
                                     // backgroundColor:'rgba(255,255,251,0.4)'
                                 }}
                                 >
                                     {
                                         rxDataLoaded &&
                                         <p className='home-toolbar-username'>
                                             {
                                                 !guest &&
                                                 textAbbreviation(data.userInfo.name,10)
                                             }
                                             {/*ایمان حاحی مصطفی زاده*/}
                                             {/*بیشتر از چند حرف که زد بیرون 3 نقطع شود */}
                                         </p>
                                     }
                                     {
                                         !rxDataLoaded &&
                                         <Grid item className='loader'/>
                                     }
                                 </Grid>
                             </>
                             }
                         </Grid>
                         {/*<Grid container alignItems={"center"} alignContent={"center"} xs={3} sm={3}/>*/}
                     </Grid>
                 </Grid>
                 }
             </Grid>
         );
     }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
    Stars:state.Stars,
    GiftHallDialog:state.GiftHall,
    QuestionNumber:state.QuestionNumber,
    CoinType:state.CoinTypeVisible
})
export default connect(mapStateToProps,{data,stars,giftHallDialog,questionNumber,coinType})( withRouter(ButtonAppBar))